<template>
	<div v-loading="dataLoading">
		<template v-if="formData">
			<tab name="18">{{id}} {{formData.title}} </tab>
			<el-form :model="formData" ref="formData" label-position="top">
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="status" :rules="[{required: true, message: '请选择纪念票开关'}]">
							<span slot="label">纪念票开关：</span>
							<el-radio-group v-model="formData.status">
								<el-radio :label="0">不开启 </el-radio>
								<el-radio :label="1">开启 </el-radio>								
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="template">
							<span slot="label">样式设置：</span>
							<el-radio-group v-model="formData.template">
								<el-radio label="souvenir_ticket_holes">默认 </el-radio>							
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
				    <el-col :xs="24" :sm="12" :xl="8">
				        <el-form-item prop="printValue" label="打印设置:">
				            <el-input v-model="formData.printValue" class="input-with-select"  :placeholder="formData.printType == 1 ? '请填写链接' : '请填写纪念票商品ID'" size="medium">
				                <el-select
				                    v-model="formData.printType"
				                    slot="prepend"
				                    placeholder="请选择"
				                >
				                    <el-option label="普通链接" :value="1"></el-option>
				                    <el-option label="纪念票商品" :value="2"></el-option>
				                </el-select>				                
				            </el-input>
				            
				        </el-form-item>
				    </el-col>
				</el-row>
				
				
				
			</el-form>			
			<div>
				<el-button @click="goBack">返回</el-button>
				<el-button v-if="$utils.have('/activity/souvenir/ticket/edit')" type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
			</div>
		</template>
	</div>
</template>

<script>
	const defaultData = {
	    printType:1, 
	    status:0,
		template:'souvenir_ticket_holes',		
	}
	import Tab from './components/tab'	
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => null
			},
			
		},
		components: {
			Tab,
			
		},
		data() {
			return {
				formData: {...defaultData}, 
				dataLoading: false,				
				btnLoading: false,				
			}
		},
		created() {
			if (this.id) {
				this.getDataDetail();
			}
		},
		methods: {
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			//获取详情
			getDataDetail() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/souvenir/ticket/detail",
						params: {
							activityId: parseInt(this.id)
						},
						method: "POST",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 ) {
							this.formData = result
						} else {
							this.$message.error(msg || "获取数据失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取数据失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			//表单提交
			onSubmit() {
				this.$refs["formData"].validate((valid) => {
					if (valid) {
						this.$request({
								url: "/activity/souvenir/ticket/edit",
								method: "POST",								
								data: {
								    ...this.formData,
								    activityId: this.id
								},
							})
							.then((res) => {
								//处理成功回调
								const {
									state,
									msg
								} = res.data;
								if (state && state == 1) {
									this.$message.success("操作成功");
									this.getDataDetail()
									
								} else {
									return this.$message.error(msg || "操作失败");
								}
							})

					}
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.font10 {
		font-size: 10px;
	}
</style>